import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Layout, Row, Col, Button, Upload, notification, Modal, Tooltip, Icon } from 'antd'
import { TextareaItem, Modal as AntdMobileModal } from 'antd-mobile'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { withTranslation } from 'react-i18next'
import Format from '../../utils/format'
import Avatar from '@material-ui/core/Avatar';
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Linkify from 'react-linkify';

import './chatPage.css'
import sendIcon from '../../assets/image/Send.png'
import downloadIcon from '../../assets/image/download.svg'
import hotelLogo from '../../assets/image/HotelLogo.jpg'

const { Content } = Layout
const messagesEndRef = React.createRef()
const STAYCHAT_API_URL = process.env.REACT_APP_STAYCHAT_API
const confirmAlert = AntdMobileModal.alert;

@inject(
    'webSettingStore',
    'chatStore',
    'templateStore'
)
@observer
class ChatPage extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.props.webSettingStore.getData();
        this.props.templateStore.getActive();

        if (process.env.REACT_APP_STAYCHAT_API) {
            this.props.chatStore.load();
            this.props.chatStore.read();
        }

        this.scrollToBottom()
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    componentWillUnmount() {
        clearInterval(this.myInterval)
    }

    setMessage = (e) => {
        this.props.chatStore.setMessage(e)
    }

    setCurrentImage = (e) => {
        this.props.chatStore.setCurrentImage(e)
    }

    setIsViewerOpen = (e) => {
        this.props.chatStore.setIsViewerOpen(e)
    }

    loadMedia = (e) => {
        e.target.style.display = "none";
        e.target.nextSibling.style.display = "inline";
    }

    openImageViewer = (image) => {
        this.setCurrentImage(image);
        this.setIsViewerOpen(true);
    }

    closeImageViewer = () => {
        this.setIsViewerOpen(false);
    }

    handleSendMessage = () => {
        const { loading, message } = this.props.chatStore;
        if (loading || !message) return;

        this.props.chatStore.setKeepLoading(true);
        this.props.chatStore.send().then(() => {
            this.props.chatStore.load();
        })
    }

    sendWithMessage = (request) => {
        this.props.chatStore.setMessage(request);
        const { loading, message } = this.props.chatStore;
        if (loading || !message) return;

        this.props.chatStore.setKeepLoading(true);
        this.props.chatStore.send().then(() => {
            this.props.chatStore.load();
        });
    }

    menuClick = (page) => {
        const { data: webSettting } = this.props.webSettingStore;
        const { activeTemplate } = this.props.templateStore;

        const confirmRedirect = () => {
            switch (page) {
                case "ird":
                    window.location.href = "/fnb";
                    break;
                default:
                    console.warn("Invalid page parameter:", page);
            }
        };

        confirmAlert(
            <div
                style={{
                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                    color: activeTemplate.templateSetting.label.color,
                    fontSize: activeTemplate.templateSetting.label.fontSize,
                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                }}>
                <span>Notice</span>
            </div>,
            <div
                style={{
                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                    color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                }}>
                <span>You will be redirected from this site.</span>
            </div>, [
            {
                text:
                    <span
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}
                    >
                        {webSettting.okText}
                    </span>,
                onPress: confirmRedirect
            }
        ]);
    }

    // ON UPLOAD

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUpload = (file) => {
        const isLessThan10Mb = file.size / 1024 / 1024 < 10;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller than 10MB!',
                placement: 'bottomRight',
            });
        }

        return isLessThan10Mb;
    }

    handleSendFile = (info) => {
        if (!info.file.status || info.file.status !== 'done') return;

        this.props.chatStore.sendFile(info.file.originFileObj).then(() => {
            this.props.chatStore.load();
        })
    }

    getMediaElement(content, fileName, mediaType, s3FilePath, isLastIndex) {
        const fileUrl = s3FilePath ? `${STAYCHAT_API_URL}/staymenuchats/getfile?fileUrl=` + encodeURIComponent(s3FilePath) : `${STAYCHAT_API_URL}/whatsapp/file/${content}`;

        const text = <Linkify componentDecorator={(decoratedHref, decoratedText, key) => (
            <a rel='noopener noreferrer' target="_blank" href={decoratedHref} key={key}>{decoratedText}</a>)}>
            {content}
        </Linkify>;

        const image = <div>
            <button type='button' className='ant-btn' onClick={(e) => this.loadMedia(e)} style={{ maxWidth: '100%', whiteSpace: 'pre-wrap', height: 'auto' }}>
                Load Image: <img src={fileUrl} style={{ maxHeight: '22px', position: 'relative', top: '-2px' }} alt=""></img>
            </button>
            <img src={fileUrl} onClick={() => this.openImageViewer(fileUrl)} style={{ maxWidth: '100%', display: 'none' }} alt=""></img>
        </div>;

        const video = <div>
            <button type='button' className='ant-btn' onClick={(e) => this.loadMedia(e)} style={{ maxWidth: '100%', whiteSpace: 'pre-wrap', height: 'auto' }}>
                Load Video: <video controls style={{ maxHeight: '22px', position: 'relative', top: '4px' }}><source src={fileUrl}></source>Your browser does not support HTML video.</video>
            </button>
            <video controls style={{ maxWidth: '100%', display: 'none' }}><source src={fileUrl}></source>Your browser does not support HTML video.</video>
        </div>;

        const document = this.isAppleOS() ?
            <div>
                <a className='ant-btn' href={fileUrl} rel='noopener noreferrer' target="_blank" style={{ maxWidth: '100%', whiteSpace: 'pre-wrap', height: 'auto' }}>{fileName}</a>
                <div className='hold-preview'>Hold for preview</div>
            </div> :
            <a className='ant-btn' href={fileUrl} download={fileName} style={{ maxWidth: '100%', whiteSpace: 'pre-wrap', height: 'auto' }}>{fileName}</a>;

        switch (mediaType) {
            case "image": return image;
            case "video": return video;
            case "document": return document;
            default: return this.getGptBaseMessage(content, isLastIndex);
        }
    }

    isAppleOS = () => {
        let platform = navigator?.userAgent || navigator?.platform || 'unknown';
        return /iPhone|iPod|iPad/.test(platform);
    }

    getGptBaseMessage(message, isLastIndex) {
        if (!message) return <></>;

        const { loading } = this.props.chatStore;
        const isConfirmation = message.includes("isConfirmation:true") || message.includes("isConfirmation: true");
        const isShowMenu = message.includes("isShowMenu") && message.includes("true");
        const isShowRatings = message.includes("isShowRatings") && message.includes("true");

        if (message.includes("|||")) {
            const stringFromApiSplit = message.split("|||");
            if (stringFromApiSplit.length > 0) {
                message = stringFromApiSplit[0];
            }
        }

        const renderButtons = () => {
            if (isShowMenu) {
                return (
                    <Button className='chatpage-button-action-inline-outlined' disabled={loading} onClick={() => this.menuClick("ird")}>
                        In-room dining menu
                    </Button>
                );
            } else if (isConfirmation && isLastIndex) {
                return (
                    <>
                        <Button className='chatpage-button-action-inline-outlined' disabled={loading} onClick={() => this.sendWithMessage('Yes')}>Yes</Button>
                        <Button className='chatpage-button-action-inline-outlined' disabled={loading} onClick={() => this.sendWithMessage('No')}>No</Button>
                        <Button className='chatpage-button-action-inline-outlined' disabled={loading} onClick={() => this.sendWithMessage('Cancel')}>Cancel</Button>
                    </>
                );
            } else if (isShowRatings && isLastIndex) {
                return (
                    <>
                        {[1, 2, 3, 4, 5].map(rating => (
                            <Button
                                key={rating}
                                className='chatpage-button-action-inline-outlined'
                                disabled={loading}
                                onClick={() => this.sendWithMessage(`⭐️ ${rating}`)}
                            >
                                ⭐️ {rating}
                            </Button>
                        ))}
                    </>
                );
            }
            return null;
        };

        return (
            <>
                <div>
                    <p>
                        <Linkify componentDecorator={(decoratedHref, decoratedText, key) => (
                            <a rel='noopener noreferrer' target="_blank" href={decoratedHref} key={key}>
                                {decoratedText}
                            </a>
                        )}>
                            {message}
                        </Linkify>
                    </p>
                </div>
                <div className='chatpage-div-button'>
                    {renderButtons()}
                </div>
            </>
        );
    }

    renderChatDetail = (chat, isLastIndex) => {
        return (
            chat.creater === 'Admin' ? (
                <Row>
                    <Col span={3} className='mg-t-5 mg-b-5 pd-l-10 txt-algn-center'>
                        <AccountCircleIcon style={{ color: '#C4A56B', fontSize: 32 }} />
                        {/* <Avatar src={hotelLogo} style={{ width: 32, height: 32 }} alt="Hotel Avatar" /> */}
                    </Col>
                    <Col span={16} className='col-body-content-chat-detail col-body-content-chat-detail-admin'>
                        <Row>
                            <Col span={20} className="font-arial-14 chat-pre-wrap">
                                {this.getMediaElement(chat.content, chat.fileName, chat.mediaType, chat.s3FilePath, isLastIndex)}
                                {
                                    chat.audioUrl ?
                                        <div>
                                            <audio className='sc-audio' src={chat.audioUrl} controls controlsList='noplaybackrate nodownload nofullscreen'></audio>
                                        </div> :
                                        null
                                }
                            </Col>
                            <Col span={4} className='col-body-content-chat-detail-time'>
                                {Format.TimeLocalOnly(chat.createTime)}
                            </Col>
                        </Row>
                    </Col>
                    <Col span={5} />
                </Row>
            ) : (
                <Row>
                    <Col span={5} />
                    <Col span={18} className='col-body-content-chat-detail col-body-content-chat-detail-guest'>
                        <Row>
                            <Col span={chat.isRead ? 18 : 20} className="font-arial-14 chat-pre-wrap">
                                {this.getMediaElement(chat.content, chat.fileName, chat.mediaType, chat.s3FilePath)}
                            </Col>
                            <Col span={4} className='col-body-content-chat-detail-time'>
                                {Format.TimeLocalOnly(chat.createTime)}
                            </Col>
                            {chat.isRead ? <Col span={2} className='col-body-content-chat-detail-read-status'><Icon type="check" /></Col> : null}
                        </Row>
                    </Col>
                    <Col span={1} />
                </Row>
            )
        )
    }

    renderNoDetail = (chat) => {
        return null; //(<React.Fragment key={chat.chatId}></React.Fragment>)
    }

    scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({ behavior: 'auto' })
    }

    renderChatDate = (chat) => {
        return (
            chat.showDate ? (<Row>
                <Col span={9} />
                <Col span={6} className='col-body-content-chat-detail-date'>
                    {Format.DateLocalOnly(chat.createTime)}
                </Col>
                <Col span={9} />
            </Row>) : (
                <React.Fragment></React.Fragment>
            )
        )
    }

    render() {
        const {
            data: webSettting
        } = this.props.webSettingStore;

        const showHeaderFooter = localStorage.getItem('showHeaderFooter')
        const { message, chatList, currentImage, isViewerOpen, loading } = this.props.chatStore;

        const Typing = () => (
            <div className="typing">
                <div className="typing__dot"></div>
                <div className="typing__dot"></div>
                <div className="typing__dot"></div>
            </div>
        );

        return (
            <Layout className='bg-white height-all bg-clr-dark-2'>
                <Content>
                    <Row className={showHeaderFooter === 'true' ? 'mg-t-60 pd-b-100 bg-clr-dark-2' : 'mg-t-60 pd-b-100 bg-clr-dark-2'}>
                        {
                            chatList.map((chat, index) => {
                                let isLastIndex = index >= chatList.length - 1;
                                return !chat.content ? (
                                    this.renderNoDetail(chat)
                                ) : (
                                    <React.Fragment key={chat.chatId}>
                                        {this.renderChatDate(chat)}
                                        {this.renderChatDetail(chat, isLastIndex)}
                                    </React.Fragment>
                                )
                            })
                        }
                    </Row>
                    <div ref={messagesEndRef} />
                    <Row>
                        <Col span={24} className={showHeaderFooter === 'true' ? 'col-body-content-chat-control' : 'col-body-content-chat-control-nofooter'}>
                            <div> {loading ? <Typing /> : null} </div>
                            <Row>
                                <Col span={2} className='txt-algn-center pd-t-4' style={{ marginTop: '6px' }}>
                                    <Upload
                                        className='needsclick'
                                        accept='image/jpeg,image/png,video/mp4,video/3gpp,.mov,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf'
                                        customRequest={this.dummyRequest}
                                        beforeUpload={this.beforeUpload}
                                        multiple={false}
                                        showUploadList={false}
                                        onChange={(info) => this.handleSendFile(info)}
                                    >
                                        <AttachFileIcon style={{ opacity: '0.5' }} />
                                    </Upload>
                                </Col>
                                <Col span={22}>
                                    <Row>
                                        <Col span={21}>
                                            <TextareaItem
                                                placeholder={webSettting ? webSettting.sendMessageText : 'Send message'}
                                                className='input-message'
                                                autoHeight
                                                value={message}
                                                onChange={this.setMessage}
                                            />
                                        </Col>
                                        <Col span={3} className='txt-algn-center pd-t-4' onClick={this.handleSendMessage} style={{ marginTop: '6px' }}>
                                            <img src={sendIcon} alt='Mic' className='img-chat-control-icon-send' />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {
                        <Modal
                            visible={isViewerOpen}
                            onCancel={this.closeImageViewer}
                            footer={[
                                <a className='ant-btn' href={currentImage} style={{ color: '#8c8c8c', borderColor: '#8c8c8c' }}>
                                    <embed src={downloadIcon} style={{ maxHeight: '0.75em', paddingRight: '0.25em' }} />
                                    Download
                                </a>
                            ]}
                            wrapClassName='stm-modal-center-footer'
                            bodyStyle={{ height: '75vh' }}
                            title={null}
                        >
                            <TransformWrapper>
                                <TransformComponent wrapperStyle={{ height: '100%' }}>
                                    <img src={currentImage} style={{ maxWidth: '100%' }} alt=""></img>
                                </TransformComponent>
                            </TransformWrapper>
                        </Modal>
                    }
                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(ChatPage)
